<template>
  <Modal
    width="920"
    :title="title"
    class-name="c-manage vertical-center-modal"
    v-model="state"
    :closable="false"
    :mask-closable="false"
    :footer-hide="true"
    @on-visible-change="bindGetData"
  >
    <!-- <Spin size="large" fix v-if="show"></Spin> -->
    <Row class="filter-box" :gutter="12" v-if="state">
      <Col span="14">
        <Form :label-width="60" inline>
          <!-- <drop-autoComplete label="创建人" member :default-option="defaultOpenId" @on-change="changeOperator"></drop-autoComplete> -->

          <FormItem :label-width="0">
            <Select v-model="opId" style="width: 180px" clearable>
              <Option v-for="item in CAOHUA_OPEN_USERS" :key="item.id" :value="item.id" :label="item.name"></Option>
            </Select>
          </FormItem>

          <FormItem label="规则类型" :label-width="70">
            <Select v-model="type" style="width: 180px">
              <Option :value="-1" label="不限"></Option>
              <Option :value="1" label="暂停计划"></Option>
              <Option :value="2" label="启用计划"></Option>
              <Option :value="3" label="更改预算"></Option>
              <Option :value="4" label="更改出价"></Option>
              <Option :value="5" label="仅消息提醒"></Option>
              <Option :value="6" label="智能模型"></Option>
              <Option :value="7" label="智能模型2"></Option>
              <Option :value="10" label="智能模型3"></Option>
            </Select>
          </FormItem>
        </Form>
      </Col>
      <Col span="6">
        <Input v-model.trim="keyword" placeholder="请输入自动化名称或ID" search enter-button @on-search="search" @on-enter="search"></Input>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Table
          ref="table"
          height="360"
          stripe
          :loading="show"
          :columns="columns"
          :data="manageList"
          @on-row-click="rowClick"
          @on-select="selectRow"
          @on-select-all="selectAll"
          @on-select-cancel="cancelRow"
          @on-select-all-cancel="cancelAll"
        >
          <template slot-scope="{ row }" slot="monitorConditionDesc">
            <span class="block-span g-error-text">{{ row.dataRange | rangeType }}</span>
            <span class="block-span" v-for="(cond, i) in row['monitorConditionDesc']" :key="i">{{ cond }}</span>
          </template>
          <template slot-scope="{ row }" slot="monitorTime">
            <span>{{ row.monitorTime | timeType }}</span>
          </template>
          <template slot-scope="{ row }" slot="ruleType">
            <span>{{ row.ruleType | ruleType }}<br />{{ row.ruleTypeInfoDesc }}</span>
          </template>
        </Table>

        <div class="footer-row">
          <Page class="pager" show-total :current.sync="pageIndex" :total="total" :page-size="pageSize" @on-change="changePageIndex" />

          <div class="btns">
            <Button type="default" @click="$emit('on-cancel')">取消</Button>
            <Button type="primary" @click="save" class="confirm">确定</Button>
          </div>
        </div>
      </Col>
    </Row>
    <!-- <Row slot="footer" :gutter="12">

    </Row> -->
  </Modal>
</template>
<script>
import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, debounce } from '@/common/js/utils'
import { getPlanAutoRule } from '@/api/manage.model'
import columns from './columns.json'
import { initPageData, CAOHUA_OPEN_USERS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([CAOHUA_OPEN_USERS])
export default {
  name: 'MonManage',
  props: {
    value: {
      type: Boolean
    },
    media: {
      type: [Number, String]
    },
    openId: {
      type: [Number, String]
    },
    selection: {
      type: Array
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    len() {
      return this.defaultData.length
    },
    title() {
      return `智能自动化选择  ${this.len ? '(已选' + this.len + '条)' : ''}`
    }
  },
  methods: {
    bindGetData(val) {
      this.manageList = []
      this.selections = []
      this.keyword = ''
      this.type = -1
      this.pageIndex = 1
      if (val) {
        this.defaultData = JSON.parse(JSON.stringify(this.selection))
        this.opId = this.openId
        if (this.opId !== null) this.getData()
      } else this.setOpenId()
    },
    getData(search) {
      let params = {
        keyWord: this.keyword,
        page_id: this.pageIndex,
        page_size: this.pageSize,
        type: this.type === -1 ? undefined : this.type,
        opId: this.opId,
        mediaId: this.media
      }

      if (search) params = Object.assign(params, search)

      this.show = true
      getPlanAutoRule(params).then((data) => {
        this.show = false
        if (data && isArray(data.list) && data.page_info) {
          this.total = data.page_info.total_number
          this.manageList = data.list.map((ret) => {
            const ids = this.defaultData.map((r) => r.id)
            if (ids.includes(ret.id)) ret._checked = true
            const { monitorConditionDesc } = ret
            const monitor = monitorConditionDesc.split(';')
            if (isArray(monitor) && monitor.length) {
              const [, ...monitorConditionInfo] = monitor
              ret.monitorConditionDesc = monitorConditionInfo
            }
            return ret
          })
        }
      })
    },
    setOperatorStorage(name, value) {
      const account = this.openId || Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    },
    setOpenId() {
      const account = this.openId || ''
      const storage = getLocal('select-monitor')
      this.defaultOpenId = storage && storage[account] ? storage[account] : account
    },
    rowClick(data, index) {
      this.$refs.table.toggleSelect(index)
    },
    changeOperator(meta) {
      this.opId = meta && meta.id
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    selectRow(selection, row) {
      this.defaultData.push(row)
    },
    selectAll() {
      this.manageList.forEach((ret) => {
        this.selectRow([], ret)
      })
    },
    cancelRow(selection, row) {
      const index = this.defaultData.findIndex((ret) => ret.id === row.id)
      if (index > -1) this.defaultData.splice(index, 1)
    },
    cancelAll() {
      this.manageList.forEach((ret) => {
        this.cancelRow([], ret)
      })
    },
    search() {
      this.pageIndex = 1
      this.getData({ keyWord: this.keyword })
    },
    save() {
      if (this.defaultData.length) {
        // 记录上次成功opId
        this.setOperatorStorage('select-monitor', this.opId || -1)
        this.$emit('on-select', this.defaultData)
      } else this.$Message.warning('您未选择一个智能自动化规则')
    }
  },
  watch: {
    opId() {
      debounce(() => {
        this.pageIndex = 1
        this.getData()
      }, 500)()
    },
    type() {
      debounce(() => {
        this.pageIndex = 1
        this.getData()
      }, 500)()
    }
  },
  filters: {
    ruleType(val) {
      let type
      switch (val) {
        case 1:
          type = '暂停计划'
          break
        case 2:
          type = '启用计划'
          break
        case 3:
          type = '更改预算'
          break
        case 4:
          type = '更改出价'
          break
        case 5:
          type = '消息提醒'
          break
        case 6:
          type = '智能模型'
          break
        case 7:
          type = '智能模型2'
          break
        case 8:
          type = '删除计划'
          break
        case 9:
          type = '复制计划'
          break
        case 10:
          type = '智能模型3'
          break
        default:
          type = '未知'
          break
      }
      return type
    },
    timeType(val) {
      let timeTxt = ''
      const monitorTime = typeof val === 'string' && JSON.parse(val)
      if (monitorTime && monitorTime.key === 'half') timeTxt = '每半个小时'
      else if (monitorTime && monitorTime.key === 'fiveMin') timeTxt = '每5分钟'
      else if (monitorTime && monitorTime.key === 'quarter') timeTxt = '每15分钟'
      else if (monitorTime && monitorTime.key === 'day') timeTxt = `每天 ${monitorTime.value}`
      return timeTxt
    },
    rangeType(val) {
      let range = ''
      if (val === 1) range = '今日实时'
      else if (val === 2) range = '近2天（含今日）'
      else if (val === 3) range = '近3天（含今日）'
      else if (val === 5) range = '近5天（含今日）'
      else if (val === 7) range = '近7天（含今日）'
      return `${range}数据：`
    }
  },
  data() {
    return {
      show: null,
      opId: null,
      keyword: '',
      type: -1,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      columns: columns,
      manageList: [],
      defaultData: [],
      defaultOpenId: ''
    }
  },
  created() {
    this.setOpenId()
  }
}
</script>
<style lang="scss" scoped>
.c-manage {
  position: relative;

  .filter-box {
    margin-bottom: 15px;

    ::v-deep .ivu-form-item {
      margin-bottom: 0;
    }
  }

  .footer-row {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btns {
      .confirm {
        margin-left: 10px;
      }
    }
  }

  .block-span {
    display: inline-block;
  }
}
</style>
